import { render, staticRenderFns } from "./ImportRecords.vue?vue&type=template&id=71d11f3b"
import script from "./ImportRecords.vue?vue&type=script&lang=js"
export * from "./ImportRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports